<template>
  <div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <span>是否删除这条评论?</span>
      <span slot="footer" class="dialog-footer">
        <div style="text-align:center">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="danger" @click="makesure()">确 定</el-button>
        </div>
      </span>
    </el-dialog>
    <div>
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline findform"
        style="margin-left:30px;margin-top:40px;display:flex"
      >
        <el-form-item style="width:33.5%;display:flex" label="商品名称：">
          <el-input placeholder="请输入商品名称：" v-model="goodsName" maxlength="20"></el-input>
        </el-form-item>
        <!-- <el-form-item label="商品编码：">
          <el-input placeholder="请输入商品编码：" v-model="goodsCode" maxlength="50"></el-input>
        </el-form-item> -->
         <el-form-item>
        <el-button type="danger" @click="findshop()">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <p class="region">评论管理</p>
    <!-- 表格 -->
    <div>
      <template>
        <el-table :data="goodListInfo" stripe border style="height:auto">
          <el-table-column prop="CommentatorName" label="评论用户"  align="center">
              <template scope="scope">
                  <span :title="scope.row.CommentatorName"  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.CommentatorName}}</span>
              </template>
          </el-table-column>
          <el-table-column prop="UserType" label="用户身份"  align="center">
            <template scope="scope">
                  <span :title="scope.row.UserType"  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.UserType}}</span>
              </template>
          </el-table-column>
            <el-table-column prop="FullGoodsName" label="评论商品"  align="center">
               <template scope="scope">
                  <span :title="scope.row.FullGoodsName"  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.FullGoodsName}}</span>
              </template>
            </el-table-column>
          <el-table-column prop="CContent" align="center" width label="评论内容">
             <template scope="scope">
                  <span :title="scope.row.CContent"  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.CContent}}</span>
              </template>
          </el-table-column>
          <el-table-column prop="CTime" align="center"  label="评论时间">
             <template scope="scope">
                  <span :title="scope.row.CTime"  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.CTime}}</span>
              </template>
          </el-table-column>
          <el-table-column
            prop="BrandName"
            v-if="BbId ==1||userType==5"
            align="center"
            width="100"
            label="操作"
            fixed="right"
          >
            <template scope="scope">
              <!-- <a href="javascript:;" @click="deleteBut(scope)" class="ahref">删除</a> -->
               <span style="color:#6786b4;margin-left:8px;cursor: pointer;" @click="deleteBut(scope)" >
                        <i class="el-icon-delete"></i>
                        删除
                  </span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    <el-pagination
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :page-size="10"
      :current-page="pageIndex"
      :total="total"
      style="float:right;margin-top:10px"
    ></el-pagination>
  </div>
</template>
<script>
import {
  SelectMerchantsCommentsList,
  DeleteMerchantsComments
} from "../../api/api";
export default {
  name: "shopcomment",
  data() {
    return {
      infoId: "",
      goodsName:"",
      goodsCode:"",
      BbId: 1,
      userType: "",
      dialogVisible: false,
      goodListInfo: [],
      formInline: {},
      pageIndex: 1,
      total: 1
    };
  },
  methods: {
    findshop(){
 this.getshoplist();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getshoplist();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    getshoplist() {
      var obj = {
        commentType: 2,
        userId: localStorage.Id,
        goodsName:this.goodsName,
        goodsCode:this.goodsCode,
        pageIndex: this.pageIndex,
        pageSize: 10
      };
      SelectMerchantsCommentsList(obj).then(data => {
        console.log(data, "评论2");
        if (data.ResultCode == 1) {
          this.goodListInfo = data.ResultObj;
          this.total = data.RowsCount;
        } else {
           this.goodListInfo = []
          this.total = data.RowsCount;
        }
      });
    },
    deleteBut(scope) {
      // this.dialogVisible = true;
      this.infoId = scope.row.Id;
             this.$swal({
       type:'warning',
    text: '是否删除这条评论？',
    showCancelButton:true,
      cancelButtonText: '取消',
    confirmButtonText: '确定',
  
  }).then((res) => {
 
   if(res.value){
     this.makesure()
   }
    
  })
    },
    makesure() {
      var obj = {
        commentId: this.infoId,
        userId: localStorage.Id
      };
      DeleteMerchantsComments(obj).then(data => {
        this.dialogVisible = false;
        if (data.ResultCode == 1) {
          this.getshoplist();
           this.$swal({
            type:"success",
            text: data.ResultMsg
          })
        }
      });
    }
  },
  mounted() {
    this.getshoplist();
    this.BbId = localStorage.BbId;
    this.userType = localStorage.UserType;
  }
};
</script>
<style scoped>
.region {
  padding-left: 50px;
  margin-top: 20px;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 1px solid #eeeeee;
  padding-bottom: 20px;
}
.ahref {
  color: #040404;
}
.ahref:hover {
  color: #F56C6C;
}
</style>


// WEBPACK FOOTER //
// goodscomment.vue?609f3c47